module.exports = __webpack_public_path__ + "static/media/confetti_example.f925a241.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/confetti_example.png
// module id = 8683
// module chunks = 0